var map = {
	"./0.png": "38ba",
	"./1.png": "92ae",
	"./10.png": "ea67",
	"./11.png": "8cb7",
	"./12.png": "980c",
	"./13.png": "ff6c",
	"./2.png": "3edc",
	"./3.png": "ea85",
	"./4.png": "b949",
	"./5.png": "11bb",
	"./6.png": "0e45",
	"./7.png": "7335",
	"./8.png": "d806",
	"./9.png": "404c",
	"./A.png": "0bea",
	"./J.png": "729f",
	"./K.png": "ca74",
	"./Q.png": "1422"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0c82";